import { cn } from '@/lib/utils';
import i18n from '@/utils/i18n';
import { DEFAULT_CONTAINER_TYPE_ICON, getImageUrl } from '@/utils/imageUrl';

type Size = 'lg' | 'md' | 'sm';

const containerClassNames: Record<Size, string> = {
  lg: 'tw:w-28 tw:h-24 tw:rounded-xl',
  md: 'tw:w-20 tw:h-16 tw:rounded-lg',
  sm: 'tw:w-16 tw:h-12 tw:rounded-md',
};

const imgWrapperClassNames: Record<Size, string> = {
  lg: 'tw:left-4',
  md: 'tw:left-3',
  sm: 'tw:left-2',
};

export function OrderFormContainerTypeThumbnail({
  image,
  color,
  size = 'lg',
}: {
  image: string | null | undefined;
  color: string | null | undefined;
  size?: Size;
}) {
  return (
    <div
      className={cn(
        'tw:relative tw:shadow tw:overflow-hidden',
        containerClassNames[size],
      )}
      style={{ backgroundColor: color ? `#${color}` : 'lightgray' }}
    >
      <div
        className={cn(
          'tw:absolute tw:top-0 tw:right-0 tw:bottom-0 tw:bg-white',
          imgWrapperClassNames[size],
        )}
      >
        <img
          src={image ? getImageUrl(128, image) : DEFAULT_CONTAINER_TYPE_ICON}
          alt={i18n.t('EventOrder:containerTypeThumbnail')}
          className="tw:w-full tw:h-full tw:aspect-square tw:object-contain"
        />
      </div>
    </div>
  );
}
